import axiosClient from "@/features/shared/http/axios_client";

export class SubscriptionApiService {
    static async createSubscription(params: {
        plan: 'monthly' | 'yearly';
        planId: string;
        razorpayPlanId?: string;
    }) {
        const response = await axiosClient.post('/createSubscription', params);
        return response.data;
    }

    static async cancelSubscription() {
        const response = await axiosClient.post('/cancelSubscription', {});
        return response.data;
    }

    static async cleanupSubscription() {
        const response = await axiosClient.post('/cleanupSubscription', {});
        return response.data;
    }
}
